import { MODIFY_CURRENT_PAGE, RESET_APPLICATION, SHOW_NOTIFIED } from "./actions";

const initialState = {
  pageInfo: {
    modified:'no',
    showNotify:true
  },
};

const ApplicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODIFY_CURRENT_PAGE:
      let data = state.pageInfo;
      data.modified = action.data;
      return {
        ...state,
        pageInfo: { ...data },
      };
      case SHOW_NOTIFIED:
        let data2 = state.pageInfo;
          data2.showNotify = action.data;
        return {
          ...state,
          pageInfo:data2,
        };
        
      case RESET_APPLICATION:
        return initialState;
    default:
      return state;
  }
};
export default ApplicationReducer;
